import { Subscription } from "rxjs";
import { ApplicationCapabilityCategories } from "~/classes/models/capabilities/application-capability-category.model";
import { CapabilitiesService } from "~/classes/models/capabilities/capabilities.service";

export const useApplicationCapabilityCategories = defineStore(
  "/application/capability-categories",
  () => {
    const applicationCapabilityCategories =
      ref<ApplicationCapabilityCategories>([]);

    const subscription = ref<Subscription | null>(null);

    const isInitialized = ref(false);
    const initialize = () => {
      if (isInitialized.value == true) {
        return;
      }

      subscription.value?.unsubscribe();
      subscription.value =
        CapabilitiesService.streamApplicationCapabilityCategories().subscribe(
          (categories) => {
            applicationCapabilityCategories.value = categories;
          }
        );
      isInitialized.value = true;
    };

    return { initialize, applicationCapabilityCategories };
  }
);
